/**
 * Typed feature flags for visitor experience.
 * Groups all useVisitorFlag() calls into a single hook.
 */

import { useVisitorFlags } from "../useFeatureFlags";

export interface VisitorFeatureFlags {
  bookmarks: boolean;
  sponsorPins: boolean;
  feedback: boolean;
  poiRatings: boolean;
  curatedLists: boolean;
  multilingual: boolean;
  mapSponsors: boolean;
  emergencyActions: boolean;
}

const FLAG_KEYS = {
  bookmarks: "visitor_bookmarks",
  sponsorPins: "sponsor_pins",
  feedback: "exit_survey",
  poiRatings: "poi_ratings",
  curatedLists: "curated_lists",
  multilingual: "multilingual",
  mapSponsors: "map_sponsors",
  emergencyActions: "emergency_actions",
} as const;

export function useVisitorFeatureFlags(orgSlug: string): VisitorFeatureFlags {
  const { flags } = useVisitorFlags(orgSlug);

  return {
    bookmarks: flags?.[FLAG_KEYS.bookmarks]?.enabled ?? false,
    sponsorPins: flags?.[FLAG_KEYS.sponsorPins]?.enabled ?? false,
    feedback: flags?.[FLAG_KEYS.feedback]?.enabled ?? false,
    poiRatings: flags?.[FLAG_KEYS.poiRatings]?.enabled ?? false,
    curatedLists: flags?.[FLAG_KEYS.curatedLists]?.enabled ?? false,
    multilingual: flags?.[FLAG_KEYS.multilingual]?.enabled ?? false,
    mapSponsors: flags?.[FLAG_KEYS.mapSponsors]?.enabled ?? false,
    emergencyActions: flags?.[FLAG_KEYS.emergencyActions]?.enabled ?? false,
  };
}
